import { GET_COUNTRY_LIST_SUCCESS } from '../../constants'
import {
  GET_FIELD_OF_WORK_SUCCESS,
  GET_E_INVOICE_OPERATORS_SUCCESS,
  LOAD_PROFILE_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  LOCATION_CHANGE,
  CLOSE_PROFILE_SNACKBAR,
  PASSWORD_UPDATE_SUCCESS,
  PASSWORD_UPDATE_FAILED,
  CLOSE_PASSWORD_SNACKBAR
} from '../../constants/employer'

const companyProfileReducer = (
  state = {
    fieldOfWork: [],
    eInvoiceOperators: [],
    userData: [],
    showSnackbar: false,
    showFailedSnackbar: false,
    showUpdatePwSnackbar: false,
    showUpdatePwFailedSnackbar: false,
    countryList: []
  },
  action
) => {
  switch (action.type) {
    case GET_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        countryList: [...action.data]
      }
    case LOAD_PROFILE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          userData: action.result
        }
      )
    case UPDATE_PROFILE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: true,
          showFailedSnackbar: false
        }
      )
    case UPDATE_PROFILE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showFailedSnackbar: true,
          showSnackbar: false
        }
      )
    case CLOSE_PROFILE_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showFailedSnackbar: false,
          showSnackbar: false
        }
      )
    case CLOSE_PASSWORD_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showUpdatePwSnackbar: false,
          showUpdatePwFailedSnackbar: false
        }
      )
    case GET_FIELD_OF_WORK_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          fieldOfWork: action.data
        }
      )

    case GET_E_INVOICE_OPERATORS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          eInvoiceOperators: action.operators
        }
      )

    case PASSWORD_UPDATE_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showUpdatePwSnackbar: true,
          showUpdatePwFailedSnackbar: false
        }
      )

    case PASSWORD_UPDATE_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showUpdatePwFailedSnackbar: true,
          showUpdatePwSnackbar: false
        }
      )
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          showSnackbar: false,
          showFailedSnackbar: false,
          showUpdatePwSnackbar: false,
          showUpdatePwFailedSnackbar: false
        }
      )
    default:
      return state
  }
}

export default companyProfileReducer
